import { AfterViewInit, ChangeDetectionStrategy, Component, DoCheck, ElementRef, Input, KeyValueDiffer, KeyValueDiffers } from '@angular/core';
import { Subject } from 'rxjs';

declare global {
	interface Window {
		jQuery: any;
	}
	interface JQuery {
		maphilight(options?: any): any;
		imageMapResize(): any;
	}
}

@Component({
	selector: 'maphilight',
	templateUrl: './maphilight.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class MaphilightComponent implements AfterViewInit, DoCheck {
	@Input() config: any;

	private readonly _configDiffer: KeyValueDiffer<any, any>;
	private readonly _el: HTMLElement;
	private _img: HTMLImageElement | null = null;
	private _map: HTMLMapElement | null = null;
	events = {
		imgLoaded: new Subject<any>(),
		updateMaphilight: new Subject<any>(),
	}

	constructor(
		private readonly elRef: ElementRef,
		differs: KeyValueDiffers
	) {
		this._el = this.elRef.nativeElement;
		this._configDiffer = differs.find({}).create();
	}

	ngAfterViewInit(): void {
		this._img = this._el.querySelector('img');
		this._map = this._el.querySelector('map');
		const id = this._el.getAttribute('id')
		this._img?.setAttribute('usemap', '#' + id + ".map");
		this._map?.setAttribute('id', id + ".map");
		this._map?.setAttribute('name', id + ".map");

		// Wait until image is loaded. Otherwise the $(img).height() in maphilight.js may return 0,
		// which causes mouseover effect to break.
		// See also  https://stackoverflow.com/questions/16084374/jquery-width-and-height-return-0-for-img-element
		if (this._img) this._img.onload = () => {
			this.events.imgLoaded.next({});
			this._updateMaphilight();
		}
	}

	ngDoCheck(): void {
		const changes = this._configDiffer.diff(this.config);
		if (changes) {
			this._updateMaphilight();
		}
	}

	private _updateMaphilight(): void {
		if (!this._img) return;
		this.events.updateMaphilight.next(null);
		(globalThis as any).jQuery(this._map)?.imageMapResize();
		(globalThis as any).jQuery(this._img)?.maphilight(this._configToApply());
	};

	private _configToApply() {
		const config = { ...this.config };
		if (config.strokeColor?.[0] == '#')
			config.strokeColor = config.strokeColor.substr(1);
		if (config.fillColor?.[0] == '#')
			config.fillColor = config.fillColor.substr(1);
		if (config.shadowColor?.[0] == '#')
			config.shadowColor = config.shadowColor.substr(1);
		return config;
	}

	/**
	 * Highlight area by id.
	 */
	highlight(id: string, status: boolean): void {
		const el = (globalThis as any).jQuery(document.getElementById(id));
		const data = el.mouseout().data('maphilight') ?? {};
		if (data.alwaysOn != status) {
			data.alwaysOn = status;
			el.data('maphilight', data).trigger('alwaysOn.maphilight');
		}
	}
}